import gql from 'graphql-tag';
import { ENPAL_REPORT_SELECTION } from '@/store/acceptanceReportSelection';
import { REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS } from '@/store/reportTemplateImages';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';
import { PROJECT_ACCEPTANCE_REPORT_PHOTO_FIELDS } from './projectAcceptanceReportFields';

const PHOTO_LIST_SELECTION = PROJECT_ACCEPTANCE_REPORT_PHOTO_FIELDS.map(
  (field) => `${field} { ${ATTACHMENT_FIELDS} }`
).join('\n');

/**
 * Data of the block project-acceptance-report-data ("Abnahmeprotokoll: Erfasste Daten"): the cards
 * (`enpalReport`), the four states the block requests, the roof type the cards branch on, the
 * photo lists of the cards and the template images of the cards. Read through
 * `Project.blocks.acceptanceReportData`, which checks the block's read permission.
 */
export const PROJECT_ACCEPTANCE_REPORT_DATA_FIELDS = gql`
  fragment projectAcceptanceReportDataFields on ProjectAcceptanceReportDataBlock {
    id
    number
    enpalReport {
      ${ENPAL_REPORT_SELECTION}
    }
    substructureVerificationState
    dcVerificationState
    acVerificationState
    scaffoldingVerificationState
    measurement {
      roofType
    }
    ${PHOTO_LIST_SELECTION}
    reportTemplateImages {
      ...reportTemplateImageFields
    }
  }
  ${REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS}
`;
